"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const constants_1 = require("@dzambalaorg/constants");
const types_1 = require("@framework/types");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const inputs_1 = require("../../../../inputs");
const items_input_1 = require("./items-input");
const validation_1 = require("./validation");
const OrderDialogForm = (props) => {
    const { selectedItem, mode, open, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, addressId, createdAt, orderItems, orderStatus, userId } = selectedItem;
    const fixedValues = { id, addressId, orderItems, orderStatus, userId };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "userId", controller: "users", getTitle: (option) => option.displayName }), (0, jsx_runtime_1.jsx)(inputs_1.AddressSelectInput, {}), mode === "edit" && (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "orderStatus", options: types_1.OrderStatus }), (0, jsx_runtime_1.jsx)(items_input_1.ItemsInput, { name: "orderItems" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.StaticInput, { name: "createdAt", value: (0, date_fns_1.format)((0, date_fns_1.parseISO)(createdAt), constants_1.humanReadableDateTimeFormat) })] }));
};
exports.OrderDialogForm = OrderDialogForm;
//# sourceMappingURL=index.js.map